module.exports = __webpack_public_path__ + "static/index/img/baikal-704.c33ced1b.jpg";